import React from 'react'

import { HeaderRow } from './styled'
import { Spacer } from '../global'
import { InlineMenuHeader } from '../InlineMenu'

const AdminHeader = () => {
  return (
    <HeaderRow>
      <Spacer height={10} />
      <InlineMenuHeader />
    </HeaderRow>
  )
}

export default AdminHeader
